<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NFL Scores</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019">2019</option>
                                <option value="2020">2020</option>
                                <option value="2021" selected>2021</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
								<option value="PRE">PRE - Pre-season</option>
                                <option value="REG" selected>REG - Regular season</option>
                                <option value="PST">PST - Past season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group" v-if="schedule.weeks">
							<label>Games</label>
							<select @change="selectSportEvent" class="form-control">
								<option value="">-- Select --</option>
                                <template v-for="week in schedule.weeks">
                                    <option v-for="sport_event in week.games" :value="sport_event.id">
                                        {{ sport_event.scheduled }} - {{ sport_event.status }} - {{ getSportEventName(sport_event) }}
                                    </option>
                                </template>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Schedule</td>
							<td>
                                <a :href="getScheduleEndpoint(true)" target="_blank">{{ getScheduleEndpoint(true) }}</a>
                            </td>
						</tr>
						<tr v-if="getPlayByPlayEndpoint()">
                            <td>Play by Play</td>
							<td>
                                <a :href="getPlayByPlayEndpoint(true)" target="_blank">{{ getPlayByPlayEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameBoxscoreEndpoint()">
                            <td>Game Boxscore</td>
							<td>
                                <a :href="getGameBoxscoreEndpoint(true)" target="_blank">{{ getGameBoxscoreEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <!--
                        <tr v-if="getGameDepthChartEndpoint()">
                            <td>Game Depth Chart</td>
							<td>
                                <a :href="getGameDepthChartEndpoint(true)" target="_blank">{{ getGameDepthChartEndpoint(true) }}</a>
                            </td>
                        </tr>
                        -->

                        <tr v-if="getGameRosterEndpoint()">
                            <td>Game Roster</td>
							<td>
                                <a :href="getGameRosterEndpoint(true)" target="_blank">{{ getGameRosterEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getGamestatisticsEndpoint()">
                            <td>Game Statistics</td>
							<td>
                                <a :href="getGamestatisticsEndpoint(true)" target="_blank">{{ getGamestatisticsEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <!--
                        <tr v-if="getGameSummaryEndpoint()">
                            <td>Game Summary</td>
							<td>
                                <a :href="getGameSummaryEndpoint(true)" target="_blank">{{ getGameSummaryEndpoint(true) }}</a>
                            </td>
                        </tr>
                        -->

                        <tr v-if="getInjuriesEndpoint()">
                            <td>Injuries</td>
							<td>
                                <a :href="getInjuriesEndpoint(true)" target="_blank">{{ getInjuriesEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getSeasonalStatisticsEndpoint(this.home)">
                            <td>Seasonal Statistics Home Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getSeasonalStatisticsEndpoint(this.away)">
                            <td>Seasonal Statistics Away Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>

                        <!--
                        <tr v-if="getTeamDepthChartEndpoint(this.home)">
                            <td>Team Depth Chart Home Team</td>
							<td>
                                <a :href="getTeamDepthChartEndpoint(this.home, true)" target="_blank">{{ getTeamDepthChartEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        
                        <tr v-if="getTeamDepthChartEndpoint(this.away)">
                            <td>Team Depth Chart Away Team</td>
							<td>
                                <a :href="getTeamDepthChartEndpoint(this.away, true)" target="_blank">{{ getTeamDepthChartEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
                        -->

                        <tr v-if="getTeamRosterEndpoint(this.home)">
                            <td>Team Roster Home Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.home, true)" target="_blank">{{ getTeamRosterEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getTeamRosterEndpoint(this.away)">
                            <td>Team Roster Away Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.away, true)" target="_blank">{{ getTeamRosterEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getCompetitorSummariesEndpoint(this.competitor_sr_id_home)">
                            <td>Competitor Summaries Home</td>
							<td>
                                <a :href="getCompetitorSummariesEndpoint(this.competitor_sr_id_home, true)" target="_blank">{{ getCompetitorSummariesEndpoint(this.competitor_sr_id_home, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getCompetitorSummariesEndpoint(this.competitor_sr_id_away)">
                            <td>Competitor Summaries Away</td>
							<td>
                                <a :href="getCompetitorSummariesEndpoint(this.competitor_sr_id_away, true)" target="_blank">{{ getCompetitorSummariesEndpoint(this.competitor_sr_id_away, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getH2HEndpoint()">
                            <td>Competitor vs Competitor</td>
							<td>
                                <a :href="getH2HEndpoint(true)" target="_blank">{{ getH2HEndpoint(true) }}</a>
                            </td>
                        </tr>
					</table>
				</div>
				
			</div>
		</div>

        <div v-if="sportEventId">
            <div id="accordion">
                <div class="card">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game" aria-expanded="true" aria-controls="collapseOne">
							Game
							</button>
						</h5>
					</div>

					<div id="game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th>week</th>
                                    <th>scheduled</th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>venue</th>
                                    <th>weather</th>
                                    <th>broadcast</th>
                                </tr>
                                <tr>
                                    <td>
                                        number: {{ week.title }}<br>
                                        id: {{ week.id }}
                                    </td>
                                    <td>
                                        {{ sport_event.scheduled }}<br>
                                        id: {{ sport_event.id }}<br>
                                        status: {{ sport_event.status }}
                                    </td>
                                    <td>
                                        name: {{ sport_event.home.name }}<br>
                                        alias: {{ sport_event.home.alias }}<br>
                                        id: {{ sport_event.home.id }}<br>
                                        sr_id: {{ sport_event.home.sr_id }}<br>
                                        reference: {{ sport_event.home.reference }}<br>
                                    </td>
                                    <td>
                                        name: {{ sport_event.away.name }}<br>
                                        alias: {{ sport_event.away.alias }}<br>
                                        id: {{ sport_event.away.id }}<br>
                                        sr_id: {{ sport_event.away.sr_id }}<br>
                                        reference: {{ sport_event.away.reference }}<br>
                                    </td>
                                    <td>
                                        name: {{ sport_event.venue.name }}<br>
                                        id: {{ sport_event.venue.id }}<br>
                                        address: {{ sport_event.venue.address }}<br>
                                        city: {{ sport_event.venue.city }}<br>
                                        state: {{ sport_event.venue.state }}<br>
                                        country: {{ sport_event.venue.country }}<br>
                                        zip: {{ sport_event.venue.zip }}<br>
                                        capacity: {{ sport_event.venue.capacity }}<br>
                                        surface: {{ sport_event.venue.surface }}<br>
                                        roof_type: {{ sport_event.venue.roof_type }}<br>
                                        sr_id: {{ sport_event.venue.sr_id }}<br>
                                    </td>
                                    <td>
                                        {{ sport_event.weather }}
                                        
                                    </td>
                                    <td>
                                        <div v-if="sport_event.broadcast">
                                            network: {{ sport_event.broadcast.network }}
                                        </div>
                                    </td>
                                </tr>
                            </table>

						</div>
					</div>
				</div>

                <div class="card" v-if="play_by_play != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#playbyplay" aria-expanded="true" aria-controls="collapseOne">
							Play by Play
							</button>
						</h5>
					</div>

					<div id="playbyplay" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home</th>
                                    <th>away</th>
                                </tr>
                                <tr>
                                    <td>
                                        scheduled: {{ play_by_play.scheduled }}<br>
                                        attendance: {{ play_by_play.attendance }}<br>
                                        utc_offset: {{ play_by_play.utc_offset }}<br>
                                        weather: {{ play_by_play.weather }}<br>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.summary && play_by_play.summary.home">
                                            id: {{ play_by_play.summary.home.id }}<br>
                                            sr_id: {{ play_by_play.summary.home.sr_id }}<br>
                                            name: {{ play_by_play.summary.home.name }}<br>
                                            market: {{ play_by_play.summary.home.market }}<br>
                                            alias: {{ play_by_play.summary.home.alias }}<br>
                                            points: {{ play_by_play.summary.home.points }}<br>
                                            used_timeouts: {{ play_by_play.summary.home.used_timeouts }}<br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.summary && play_by_play.summary.away">
                                            id: {{ play_by_play.summary.away.id }}<br>
                                            sr_id: {{ play_by_play.summary.away.sr_id }}<br>
                                            name: {{ play_by_play.summary.away.name }}<br>
                                            market: {{ play_by_play.summary.away.market }}<br>
                                            alias: {{ play_by_play.summary.away.alias }}<br>
                                            points: {{ play_by_play.summary.away.points }}<br>
                                            used_timeouts: {{ play_by_play.summary.away.used_timeouts }}<br>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div v-for="period in play_by_play.periods">

                                <h3>Period - {{ period.number}}</h3>
                                <span v-if="period.scoring"> home score: {{ period.scoring.home.points }}<br></span>
                                <span v-if="period.scoring"> away score: {{ period.scoring.away.points }}<br></span>

                                <table class="table">
                                    <tr>
                                        <th>clock</th>
                                        <th></th>
                                        <th>points</th>
                                        <th>location</th>
                                        <th>statistics</th>  
                                    </tr>
                                    <template v-for="pbp in period.pbp">
                                        <tr v-if="pbp.events" v-for="event in pbp.events">
                                            <td>{{ event.clock }}</td>
                                            <td>
                                                id: {{ event.id }}<br>
                                                <span v-if="event.type"> type: {{ event.type }}<br></span>
                                                <span v-if="event.event_type"> event_type: {{ event.event_type }}<br></span>
                                                <span v-if="event.sequence"> sequence: {{ event.sequence }}<br></span>
                                                <span v-if="event.description"> summary: {{ event.description }}<br></span>
                                                <span v-if="event.updated"> updated: {{ event.updated }}<br></span>
                                                <span v-if="event.number"> number: {{ event.number }}<br></span>
                                                <span v-if="event.wall_clock"> wall_clock: {{ event.wall_clock }}<br></span>
                                                <span v-if="event.play_type"> number: {{ event.play_type }}<br></span>
                                                <span v-if="event.play_clock"> wall_clock: {{ event.play_clock }}<br></span>

                                                <div v-if="event.attribution">
                                                    attribution: {{ event.attribution.market }} {{ event.attribution.name }}
                                                </div>
                                            </td>
                                            <td>
                                                <span v-if="event.home_points"> home_points: {{ event.home_points }}<br></span>
                                                <span v-if="event.away_points"> away_points: {{ event.away_points }}<br></span>
                                            </td>
                                            <td>
                                                <div v-if="event.start_situation && event.end_situation">
                                                    <span v-if="event.start_situation.location.yardline"> start_location_yardline: {{ event.start_situation.location.yardline }}<br></span>
                                                    <span v-if="event.end_situation.location.yardline"> end_location_yardline: {{ event.end_situation.location.yardline }}<br></span>
                                                </div>
                                            </td>
                                            <td>
                                                <div v-if="event.statistics">
                                                    <div v-for="stat in event.statistics" style="border-bottom:1px solid #ccc;">
                                                        type: {{ stat.stat_type }}<br>
                                                        <span v-if="stat.attempt">attempt: {{ stat.attempt }}<br></span>
                                                        <span v-if="stat.yards">shotyards_type: {{ stat.yards }}<br></span>
                                                        <span v-if="stat.tackle">tackle: {{ stat.tackle }}<br></span>
                                                        <span v-if="stat.missed_tackles">missed_tackles: {{ stat.missed_tackles }}<br></span>
                                                        <span v-if="stat.att_yards">att_yards: {{ stat.att_yards }}<br></span>
                                                        <span v-if="stat.pocket_time">pocket_time: {{ stat.pocket_time }}<br></span>
                                                        <span v-if="stat.yards_after_contact">yards_after_contact: {{ stat.yards_after_contact }}<br></span>
                                                        <span v-if="stat.team">team: {{ stat.team.name }}<br></span>
                                                        <span v-if="stat.player">player: {{ stat.player.name }}<br></span>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_boxscore != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-boxscore" aria-expanded="true" aria-controls="collapseOne">
							Game Boxscore
							</button>
						</h5>
					</div>

					<div id="game-boxscore" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home team scoring</th>
                                    <th>away team scoring</th>
                                </tr>
                                <tr>
                                    <td>
                                        completed: {{ game_boxscore.completed }}<br>
                                        clock: {{ game_boxscore.clock }}<br>
                                        quarter: {{ game_boxscore.quarter }}<br>
                                        status: {{ game_boxscore.status }}<br>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.scoring">
                                            points: {{ game_boxscore.summary.home.points }}<br>
                                            <div v-for="scoring in game_boxscore.scoring" style="border-top: 1px solid #ccc">
                                                scoring: {{ scoring.home_points }}<br>
                                                period_type: {{ scoring.period_type }}<br>
                                                number: {{scoring.number}}<br>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.scoring">
                                            points: {{ game_boxscore.summary.away.points }}<br>
                                            <div v-for="scoring in game_boxscore.scoring" style="border-top: 1px solid #ccc">
                                                scoring: {{ scoring.away_points }}<br>
                                                period_type: {{scoring.period_type}}<br>
                                                number: {{scoring.number}}<br>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <h3>Scoring drives</h3>

                            <table class="table">
                                <tr>
                                    <th>duration</th>
                                    <th>quarter</th>
                                    <th>sequence</th>
                                    <th>team</th>
                                    <th>scores</th>
                                </tr>
                                <tr v-for="scoring_drive in game_boxscore.scoring_drives">
                                    <td> 
                                        {{ scoring_drive.duration }}<br>
                                    </td>
                                    <td>
                                        id: {{ scoring_drive.quarter.id }}<br>
                                        number: {{ scoring_drive.quarter.number }}<br>
                                        sequence: {{ scoring_drive.quarter.sequence }}<br>
                                    </td>
                                    <td>{{ scoring_drive.sequence }}</td>
                                    <td>
                                        id: {{ scoring_drive.team.id }}<br>
                                        name: {{ scoring_drive.team.name }}<br>
                                        market: {{ scoring_drive.team.market }}<br>
                                        alias: {{ scoring_drive.team.alias }}<br>
                                        reference: {{ scoring_drive.team.reference }}<br>
                                        sr_id: {{ scoring_drive.team.sr_id }}<br>
                                    </td>
                                    <td>
                                        <table class="table">
                                            <tr>
                                                <th>id</th>
                                                <th>clock</th>
                                                <th>home points</th>
                                                <th>away points</th>
                                                <th>play type</th>
                                                <th>type</th>
                                            </tr>
                                            <tr v-for="play in scoring_drive.plays">
                                                <td>{{ play.id }}</td>
                                                <td>{{ play.clock }}</td>
                                                <td>{{ play.home_points }}</td>
                                                <td>{{ play.away_points }}</td>
                                                <td>{{ play.play_type }}</td>
                                                <td>{{ play.type }}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
						</div>
					</div>
				</div>

                <!--
                <div class="card" v-if="game_depth_chart != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-depth-chart" aria-expanded="true" aria-controls="collapseOne">
							Game Depth Chart
							</button>
						</h5>
					</div>

					<div id="game-depth-chart" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NFLDepthChart
                                :depth_chart="game_depth_chart.home_team"
                                team_role="home_team"
                            ></NFLDepthChart>

                            <NFLDepthChart
                                :depth_chart="game_depth_chart.away_team"
                                team_role="away_team"
                            ></NFLDepthChart>

						</div>
					</div>
				</div>
                -->

                <div class="card" v-if="game_roster != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-roster" aria-expanded="true" aria-controls="collapseOne">
							Game Roster
							</button>
						</h5>
					</div>

					<div id="game-roster" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <div v-if="game_roster.home">

                                <NFLRoster
                                    :roster="game_roster.home" 
                                ></NFLRoster>

                            </div>

                            <div v-if="game_roster.away">
                                <NFLRoster
                                    :roster="game_roster.away"
                                ></NFLRoster>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_statistics != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-statistics" aria-expanded="true" aria-controls="collapseOne">
							Game Statistics
							</button>
						</h5>
					</div>

					<div id="game-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>Home Team</h3>

                            <div v-if="game_statistics.statistics">
                                <NFLGameStatistics
                                    :statistics="game_statistics.statistics.home"
                                ></NFLGameStatistics>
                            </div>
                            

                            <h3>Away Team</h3>

                            <div v-if="game_statistics.statistics">
                                <NFLGameStatistics
                                    :statistics="game_statistics.statistics.away"
                                ></NFLGameStatistics>
                            </div>
                            

						</div>
					</div>
				</div>

                <!--
                <div class="card" v-if="game_summary != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-summary" aria-expanded="true" aria-controls="collapseOne">
							Game Summary
							</button>
						</h5>
					</div>

					<div id="game-summary" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-for="(value, name) in game_summary.home_team">
                                <div v-if="typeof(value) == 'object'">
                                    
                                    {{ name }}: 
                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                
                                        <div v-if="typeof(value_2) == 'object'">
                                    
                                            {{ name_2 }}: 
                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                
                                                {{ name_3 }}: {{ value_3 }}
                                            
                                            </div>

                                        </div>
                                        <div v-else>
                                            {{ name_2 }}: {{ value_2 }}
                                        </div>
                                    
                                    </div>

                                </div>
                                <div v-else>
                                    {{ name }}: {{ value }}
                                </div>
                                
                            </div> 

                            <h3>away_team</h3>

                            <div v-for="(value, name) in game_summary.away_team">
                                <div v-if="typeof(value) == 'object'">
                                    
                                    {{ name }}: 
                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                
                                        <div v-if="typeof(value_2) == 'object'">
                                    
                                            {{ name_2 }}: 
                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                
                                                {{ name_3 }}: {{ value_3 }}
                                            
                                            </div>

                                        </div>
                                        <div v-else>
                                            {{ name_2 }}: {{ value_2 }}
                                        </div>
                                    
                                    </div>

                                </div>
                                <div v-else>
                                    {{ name }}: {{ value }}
                                </div>
                                
                            </div>                            

						</div>
					</div>
				</div>
                -->

                <div class="card" v-if="injuries != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#injuries" aria-expanded="true" aria-controls="collapseOne">
							Weekly Injuries
							</button>
						</h5>
					</div>

					<div id="injuries" class="collapse show" aria-labelledby="headingOne">
						<div v-if="homeInjuries" class="card-body">
							
                            <div v-if="homeInjuries.players">
                            <h3>Home team</h3>
                            <h4>{{homeInjuries.name}} {{ homeInjuries.market }}</h4>
                            <h5> 
                                id: {{ homeInjuries.id }} </br>
                                alias: {{ homeInjuries.alias }} </br>
                                sr_id: {{ homeInjuries.sr_id }} </br>
                            </h5>
                                <table class="table">
                                    <tr>
                                        <th>player</th>
                                        <th>injury</th>
                                    </tr>
                                    <template v-for="player in homeInjuries.players">
                                        <tr v-if="player.injuries" v-for="injury in player.injuries">
                                            <td>
                                                id: {{ player.id }} </br>
                                                name: {{ player.name }} </br>
                                                jersey: {{ player.jersey }} </br>
                                                reference: {{ player.reference }} </br>
                                                position: {{ player.position }} </br>
                                                sr_id: {{ player.sr_id }} </br>
                                            </td>
                                            <td>
                                                <div v-if="injury.status_date">
                                                    status_date: {{ injury.status_date }} </br>
                                                </div>
                                                <div v-if="injury.status">
                                                    status: {{ injury.status }} </br>
                                                </div>
                                                    <div v-if="injury.practice && injury.practice.status">
                                                    practice_status: {{ injury.practice.status }} </br>
                                                </div>
                                                    <div v-if="injury.primary">
                                                    primary: {{ injury.primary }} </br>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table>  
                            </div>

                            <h3>Away team</h3>
                            <h4>{{awayInjuries.name}} {{ awayInjuries.market }}</h4>
                            <h5> 
                                id: {{ awayInjuries.id }} </br>
                                alias: {{ awayInjuries.alias }} </br>
                                sr_id: {{ awayInjuries.sr_id }} </br>
                            </h5>
                                <table class="table">
                                    <tr>
                                        <th>player</th>
                                        <th>injury</th>
                                    </tr>
                                    <template v-for="player in awayInjuries.players">
                                        <tr v-if="player.injuries" v-for="injury in player.injuries">
                                            <td>
                                                id: {{ player.id }} </br>
                                                name: {{ player.name }} </br>
                                                jersey: {{ player.jersey }} </br>
                                                reference: {{ player.reference }} </br>
                                                position: {{ player.position }} </br>
                                                sr_id: {{ player.sr_id }} </br>
                                            </td>
                                            <td>
                                                <div v-if="injury.status_date">
                                                    status_date: {{ injury.status_date }} </br>
                                                </div>
                                                <div v-if="injury.status">
                                                    status: {{ injury.status }} </br>
                                                </div>
                                                    <div v-if="injury.practice && injury.practice.status">
                                                    practice_status: {{ injury.practice.status }} </br>
                                                </div>
                                                    <div v-if="injury.primary">
                                                    primary: {{ injury.primary }} </br>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table>  
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="seasonal_statistics_home != [] && seasonal_statistics_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#seasonal-statistics" aria-expanded="true" aria-controls="collapseOne">
							Seasonal Statistics
							</button>
						</h5>
					</div>

					<div id="seasonal-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>Home Team</h3>

                            <div v-if="seasonal_statistics_home">
                                <NFLSeasonalStatistics
                                    :statistics="seasonal_statistics_home"
                                ></NFLSeasonalStatistics>
                            </div>
                            

                            <h3>Away Team</h3>

                            <div v-if="seasonal_statistics_away">
                                <NFLSeasonalStatistics
                                    :statistics="seasonal_statistics_away"
                                ></NFLSeasonalStatistics>
                            </div>
                                            
						</div>
					</div>
				</div>

                <!--
                <div class="card" v-if="team_depth_chart_home != [] && team_depth_chart_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#team-depth-chart" aria-expanded="true" aria-controls="collapseOne">
							Team Depth Chart
							</button>
						</h5>
					</div>

					<div id="team-depth-chart" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NFLDepthChart
                                :depth_chart="team_depth_chart_home"
                                team_role="home_team"
                            ></NFLDepthChart>

                            <NFLDepthChart
                                :depth_chart="team_depth_chart_away"
                                team_role="away_team"
                            ></NFLDepthChart>
                                            
						</div>
					</div>
				</div>
                -->

                <div class="card" v-if="team_roster_home != [] && team_roster_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#team-roster" aria-expanded="true" aria-controls="collapseOne">
							Team Roster
							</button>
						</h5>
					</div>

					<div id="team-roster" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NFLRoster
                                :roster="team_roster_home"
                                team_role="home_team"
                            ></NFLRoster>

                            <NFLRoster
                                :roster="team_roster_away"
                                team_role="away_team"
                            ></NFLRoster>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="competitor_summaries_home != [] && competitor_summaries_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#competitor-summaries" aria-expanded="true" aria-controls="collapseOne">
							Competitors Summaries
							</button>
						</h5>
					</div>
                    <div id="competitor-summaries" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">

                            <h3>Home team</h3>
                            <h4>
                                {{ sport_event.home.name }}<br>
                            </h4>
                            <h5>
                                alias: {{ sport_event.home.alias }}<br>
                                id: {{ sport_event.home.id }}<br>
                                sr_id: {{ sport_event.home.sr_id }}<br>
                            </h5>
                            <table class="table">
                                <tr>
                                    <th>score</th>
                                    <th>date</th>
                                    <th>competitors names</th>
                                    <th>winner</th>
                                </tr>
                                <template v-if="new Date(summary.sport_event.start_time) < Date.now()" v-for="summary in competitor_summaries_home.summaries" >
                                    <tr v-if="summary.sport_event_status">
                                        <td>
                                            {{summary.sport_event_status.home_score}}-{{summary.sport_event_status.away_score}}                                        
                                        </td>
                                        <td>
                                            {{summary.sport_event.start_time}}                                       
                                        </td>
                                        <td>
                                            {{summary.sport_event.competitors[0].name}} vs  {{summary.sport_event.competitors[1].name}}                                      
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[0].id">
                                            {{summary.sport_event.competitors[0].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[1].id">
                                            {{summary.sport_event.competitors[1].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == null">
                                            DRAW                                     
                                        </td>
                                    </tr>    
                                </template>
                            </table>
                            <h3>Away team</h3>
                            <h4>
                                {{ sport_event.away.name }}<br>
                            </h4>
                            <h5>
                                alias: {{ sport_event.away.alias }}<br>
                                id: {{ sport_event.away.id }}<br>
                                sr_id: {{ sport_event.away.sr_id }}<br>
                            </h5>
                            <table class="table">
                                <tr>
                                    <th>score</th>
                                    <th>date</th>
                                    <th>competitors names</th>
                                    <th>winner</th>
                                </tr>
                                <template v-if="new Date(summary.sport_event.start_time) < Date.now()" v-for="summary in competitor_summaries_away.summaries" >
                                    <tr v-if="summary.sport_event_status">
                                        <td>
                                            {{summary.sport_event_status.away_score}}-{{summary.sport_event_status.away_score}}                                        
                                        </td>
                                        <td>
                                            {{summary.sport_event.start_time}}                                       
                                        </td>
                                        <td>
                                            {{summary.sport_event.competitors[0].name}} vs  {{summary.sport_event.competitors[1].name}}                                      
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[0].id">
                                            {{summary.sport_event.competitors[0].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == summary.sport_event.competitors[1].id">
                                            {{summary.sport_event.competitors[1].name}}                                       
                                        </td>
                                        <td v-if="summary.sport_event_status.winner_id == null">
                                            DRAW                                     
                                        </td>
                                    </tr>   
                                        
                                </template>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card" v-if="h2h != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#h2h" aria-expanded="true" aria-controls="collapseOne">
							Competitor vs Competitor
							</button>
						</h5>
					</div>

					<div id="h2h" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <div v-if="h2h.last_meetings">
                            <h3>{{h2h.competitors[0].name}} vs {{h2h.competitors[1].name}}</h3>
                                <table class="table">
                                    <tr>
                                        <th>Scheduled</th>
                                        <th>Venue</th>
                                        <th>Home</th>
                                        <th>Away</th>
                                        <th>Home score</th>
                                        <th>Away score</th>
                                        <th>Winner</th>
                                    </tr>
                                    <tr v-if="meeting.sport_event && meeting.sport_event_status" v-for="meeting in h2h.last_meetings">
                                        <td>{{meeting.sport_event.start_time}}</td>
                                        <td>{{meeting.sport_event.venue.name}} in {{meeting.sport_event.venue.city_name}}</td>
                                        <template v-if="meeting.sport_event.competitors[0].qualifier == 'home'">
                                            <td>{{meeting.sport_event.competitors[0].name}}</td>
                                            <td>{{meeting.sport_event.competitors[1].name}}</td>
                                        </template>
                                        <template v-if="meeting.sport_event.competitors[1].qualifier == 'home'">
                                            <td>{{meeting.sport_event.competitors[1].name}}</td>
                                            <td>{{meeting.sport_event.competitors[0].name}}</td>
                                        </template>
                                        <td>{{meeting.sport_event_status.home_score}}</td>
                                        <td>{{meeting.sport_event_status.away_score}}</td>
                                        <td v-if="meeting.sport_event_status.winner_id == meeting.sport_event.competitors[0].id">{{meeting.sport_event.competitors[0].name}}</td>
                                        <td v-if="meeting.sport_event_status.winner_id == meeting.sport_event.competitors[1].id">{{meeting.sport_event.competitors[1].name}}</td>
                                        <td v-if="meeting.sport_event_status.home_score == meeting.sport_event_status.away_score">DRAW</td>
                                    </tr>
                                </table>  
                            </div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import NFLGameStatistics from './components/NFLGameStatistics.vue'
import NFLSeasonalStatistics from './components/NFLSeasonalStatistics.vue'
import NFLDepthChart from './components/NFLDepthChart.vue'
import NFLRoster from './components/NFLRoster.vue'

export default {
    name: 'app',
    components: {
        NFLGameStatistics,
        NFLSeasonalStatistics,
        NFLDepthChart,
        NFLRoster,
	},
    created: function() {

        this.loadSchedule();
    },
    data: function() {
        return {            
            apiKey: 'fz5pevvxgmnxt2nu4pnjptqg',
            globalApiKey: 'mass6hqg5pytt3keka63tpds',
            year: 2021,
            season: "REG",
            injuryWeek: 1,
            schedule: [],
            play_by_play: [],
            sportEventId: '',
            sport_event: '',
            week: '',
            home: '',
            away: '',
            competitor_sr_id_home: '',
            competitor_sr_id_away: '',
            homeInjuries: {},
            awayInjuries: {},
            game_boxscore: [],
            game_depth_chart: [],
            game_roster: [],
            game_statistics: [],
            game_summary: [],
            injuries: [],
            h2h: [],
            seasonal_statistics_home: [],
            seasonal_statistics_away: [],
            team_depth_chart_home: [],
            team_depth_chart_away: [],
            team_roster_home: [],
            team_roster_away: [],
            competitor_summaries_home: [],
            competitor_summaries_away: [],
            statistics_types: [
                {
                    name: "two_point_conversion",
                    fields: [
                        "att",
                        "pass",
                        "rush",
                        "rec",
                        "failed",
                    ]
                },
                {
                    name: "touchdowns",
                    fields: [
                        "pass",
                        "rush",
                        "int",
                        "fum_ret",
                        "punt_ret",
                        "kick_ret",
                        "fg_ret",
                        "other",
                    ]
                },
                {
                    name: "third_down_efficiency",
                    fields: [
                        "att",
                        "conv",
                        "pct",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "rushing",
                    fields: [
                        "att",
                        "yds",
                        "avg",
                        "lg",
                        "td",
                        "fd",
                        "fd_pct",
                        "sfty",
                        "rz_att",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "redzone_efficiency",
                    fields: [
                        "att",
                        "td",
                        "pct",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ]
                },
                {
                    name: "receiving",
                    fields: [
                        "tar",
                        "rec",
                        "yds",
                        "yac",
                        "fd",
                        "avg",
                        "td",
                        "lg",
                        "rz_tar",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "punting",
                    fields: [
                        "punts",
                        "yds",
                        "net_yds",
                        "lg",
                        "blk",
                        "in20",
                        "tb",
                        "ret",
                        "sfty",
                        "avg",
                        "net_avg",
                        "ret_yds",
                        "avg_ret",
                        "in20_pct",
                        "tb_pct",
                    ]
                },
                {
                    name: "punt_return",
                    fields: [
                        "returns",
                        "yds",
                        "fc",
                        "lg",
                        "td",
                        "avg",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "penalty",
                    fields: [
                        "num",
                        "yds",
                        "fd",
                    ]
                },
                {
                    name: "passing",
                    fields: [
                        "att",
                        "cmp",
                        "yds",
                        "lg",
                        "sk",
                        "sk_yds",
                        "td",
                        "int",
                        "int_td",
                        "fd",
                        "sfty",
                        "rz_att",
                        "rating",
                        "avg",
                        "cmp_pct",
                        "cmp_avg",
                        "td_pct",
                        "int_pct",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "kickoffs",
                    fields: [
                        "kicks",
                        "yds",
                        "net_yds",
                        "lg",
                        "endzone",
                        "in20",
                        "tb",
                        "ret",
                        "avg",
                        "net_avg",
                        "ret_yds",
                        "avg_ret",
                        "in20_pct",
                        "tb_pct",
                    ]
                },
                {
                    name: "kick_return",
                    fields: [
                        "returns",
                        "yds",
                        "fc",
                        "lg",
                        "td",
                        "avg",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "goal_efficiency",
                    fields: [
                        "att",
                        "td",
                        "pct",
                    ]
                },
                {
                    name: "fumbles",
                    fields: [
                        "fum",
                        "lost",
                        "oob",
                        "own_rec",
                        "own_rec_yds",
                        "own_rec_td",
                        "force_fum",
                        "opp_rec",
                        "opp_rec_yds",
                        "opp_rec_td",
                    ]
                },
                {
                    name: "fourth_down_efficiency",
                    fields: [
                        "att",
                        "conv",
                        "pct",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "first_downs",
                    fields: [
                        "num",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "first_downs",
                    fields: [
                        "num",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "field_goal",
                    fields: [
                        "att",
                        "made",
                        "pct",
                        "lg",
                        "att_19",
                        "made_19",
                        "att_29",
                        "made_29",
                        "att_39",
                        "made_39",
                        "att_49",
                        "made_49",
                        "att_50",
                        "made_50",
                    ]
                },
                {
                    name: "extra_point",
                    fields: [
                        "att",
                        "made",
                        "pct",
                        "blk",
                    ]
                },
                {
                    name: "defensive_conversion",
                    fields: [
                        "att",
                        "cmp",
                        "failed",
                    ]
                },
                {
                    name: "defense",
                    fields: [
                        "tackle",
                        "ast",
                        "comb",
                        "tlost",
                        "sack",
                        "sack_yds",
                        "sfty",
                        "int",
                        "int_yds",
                        "int_lg",
                        "int_td",
                        "force_fum",
                        "fum_rec",
                        "fum_td",
                        "qh",
                        "pd",
                        "bk",
                        "sfty_1pt",
                        "sp_tackle",
                        "sp_ast",
                        "sp_comb",
                        "sp_force_fum",
                        "sp_fum_rec",
                        "misc_tackle",
                        "misc_ast",
                        "misc_comb",
                        "misc_force_fum",
                        "misc_fum_rec",
                    ]
                },
            ]
        }
    }, 
    methods: {
        getScheduleEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/games/${this.year}/${this.season}/schedule.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayByPlayEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/games/${this.sportEventId}/pbp.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayByPlayDetailsEndpoint: function(baseUrl, showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nfl-rt1/${baseUrl}?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameBoxscoreEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/games/${this.sportEventId}/boxscore.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameDepthChartEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl-rt1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/depthchart.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameRosterEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/games/${this.sportEventId}/roster.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGamestatisticsEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/games/${this.sportEventId}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameSummaryEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl-rt1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/summary.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getInjuriesEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/seasons/${this.year}/${this.season}/${this.injuryWeek}/injuries.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeasonalStatisticsEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/seasons/${this.year}/${this.season}/teams/${team}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getTeamDepthChartEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/nfl-rt1/teams/${team}/depthchart.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getTeamRosterEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/teams/${team}/full_roster.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getCompetitorSummariesEndpoint: function(sr_id, showBetradarUrl = false) {

            if(sr_id == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/americanfootball/production/v2/en/competitors/${sr_id}/summaries.json?api_key=${this.globalApiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getH2HEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.competitor_sr_id_home == '' || this.competitor_sr_id_away == '')  return ''

            let url = `https://kaxmatrix.com/oddsapi/americanfootball/production/v2/en/competitors/${this.competitor_sr_id_home}/versus/${this.competitor_sr_id_away}/summaries.json?api_key=${this.globalApiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        loadSchedule: function() {

            // get full list of tournaments
            axios.get(this.getScheduleEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('schedule', response.data);
                this.schedule = response.data;

            }, (error) => {
                console.log(error)
            });
        },

        loadPlayByPlay: function() {

            if(this.getPlayByPlayEndpoint() == '') return;

            axios.get(this.getPlayByPlayEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('play-by-play', response.data);
                this.play_by_play = response.data;
                this.loadPlayByPlayDetails();
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayByPlayDetails: function() {
            return;

            let requestsCounter = 0;

            for(let quartersCount = 0; quartersCount < this.play_by_play.quarters.length; quartersCount++) {

                let currentQuarter = this.play_by_play.quarters[quartersCount];

                for(let pbpCount = 0; pbpCount < currentQuarter.pbp.length; pbpCount++) {
                    
                    let currentPbp = currentQuarter.pbp[pbpCount];

                    if(currentPbp.actions) {
                        for(let actionsCount = 0; actionsCount < currentPbp.actions.length; actionsCount++) {
                        
                            let currentAction = currentPbp.actions[actionsCount];
                            let requestUrl = this.getPlayByPlayDetailsEndpoint(currentAction.details);
                            requestsCounter++;

                            setTimeout(function() {

                                
                                console.log(new Date(), 'requestsCounter', requestsCounter);

                                axios.get(requestUrl, 
                                    { crossdomain: true })
                                .then((response) => {
                                    
                                    console.log('play-by-play detail', response.data);

                                    //this.play_by_play = response.data;
                                    
                                    //this.loadPlayByPlayDetails();
                                
                                }, (error) => {
                                    console.log(error)
                                });
                            }, requestsCounter * 500);
                            
                        }
                    }
                    
                }
            }
        },

        loadGameBoxscore: function() {

            if(this.getGameBoxscoreEndpoint() == '') return;

            axios.get(this.getGameBoxscoreEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-boxscore', response.data);

                this.game_boxscore = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameDepthChart: function() {

            if(this.getGameDepthChartEndpoint() == '') return;

            axios.get(this.getGameDepthChartEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-depth-chart', response.data);

                this.game_depth_chart = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameRoster: function() {

            if(this.getGameRosterEndpoint() == '') return;

            axios.get(this.getGameRosterEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-roster', response.data);

                this.game_roster = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameStatistics: function() {

            if(this.getGamestatisticsEndpoint() == '') return;

            axios.get(this.getGamestatisticsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-statistics', response.data);

                this.game_statistics = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameSummary: function() {

            if(this.getGameSummaryEndpoint() == '') return;

            axios.get(this.getGameSummaryEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-summary', response.data);

                this.game_summary = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadInjuries: function() {

            if(this.getInjuriesEndpoint() == '') return;

            axios.get(this.getInjuriesEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('injuries', response.data);

                this.homeInjuries = response.data.teams.find(team => team.id == this.home);
                this.awayInjuries = response.data.teams.find(team => team.id == this.away);

            }, (error) => {
                console.log(error)
            });
        },

        loadSeasonalStatistics: function() {

            if(this.getSeasonalStatisticsEndpoint(this.home) == ''
                || this.getSeasonalStatisticsEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSeasonalStatisticsEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_home', response.data);

                this.seasonal_statistics_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSeasonalStatisticsEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_away', response.data);

                this.seasonal_statistics_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadTeamDepthChart: function() {

            if(this.getTeamDepthChartEndpoint(this.home) == ''
                || this.getTeamDepthChartEndpoint(this.away) == ''
            ) return;

            axios.get(this.getTeamDepthChartEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_depth_chart_home', response.data);

                this.team_depth_chart_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getTeamDepthChartEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_depth_chart_away', response.data);

                this.team_depth_chart_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadTeamRoster: function() {

            if(this.getTeamRosterEndpoint(this.home) == ''
                || this.getTeamRosterEndpoint(this.away) == ''
            ) return;

            axios.get(this.getTeamRosterEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_home', response.data);

                this.team_roster_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getTeamRosterEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_away', response.data);

                this.team_roster_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadCompetitorSummaries: function() {
            if(this.getCompetitorSummariesEndpoint(this.competitor_sr_id_home) == ''
                || this.getCompetitorSummariesEndpoint(this.competitor_sr_id_away) == ''
            ) return;

            axios.get(this.getCompetitorSummariesEndpoint(this.competitor_sr_id_home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitor_summaries_home', response.data);

                this.competitor_summaries_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getCompetitorSummariesEndpoint(this.competitor_sr_id_away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitor_summaries_away', response.data);

                this.competitor_summaries_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadH2H: function() {

            if(this.getH2HEndpoint() == '') return;

            axios.get(this.getH2HEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitor vs competitor', response.data);
                this.h2h = response.data;

            }, (error) => {
                console.log(error)
            });
        },

        getSportEventName: function(sport_event) {

            let name = sport_event.home.name + ' vs ' + sport_event.away.name;

            return name;
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
			this.loadSchedule();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
			this.loadSchedule();
        },

        selectSportEvent: function(event) {
			  
            let sportEventId = event.target.value;
            let sport_event = '';
            let week = '';

            this.schedule.weeks.forEach(current_week => {
                
                let temp_sport_event = current_week.games.find(function(game) {
                    return game.id == sportEventId;
                });

                if(temp_sport_event) {
                    sport_event = temp_sport_event;
                    week = current_week;
                }
            });

            this.sportEventId = event.target.value;
            this.sport_event = sport_event;
            this.week = week;
            this.injuryWeek = this.week.title;
            this.home = sport_event.home.id;
            this.away = sport_event.away.id;
            this.competitor_sr_id_home = this.sport_event.home.sr_id;
            this.competitor_sr_id_away = this.sport_event.away.sr_id;

            this.loadPlayByPlay();	
            this.loadGameBoxscore();
            //this.loadGameDepthChart();
            this.loadGameRoster();
            this.loadGameStatistics();
            //this.loadGameSummary();
            this.loadInjuries();
            this.loadSeasonalStatistics();
            //this.loadTeamDepthChart();
            this.loadTeamRoster();  
            this.loadCompetitorSummaries();
            this.loadH2H();
        },
    },
}
</script>